import { Configuration, PopupRequest, RedirectRequest } from '@azure/msal-browser';

// Debug: Log the current origin
console.log('MSAL Config - Current origin:', window.location.origin);
console.log('MSAL Config - Environment REDIRECT_URI:', process.env.REACT_APP_REDIRECT_URI);

// MSAL configuration
export const msalConfig: Configuration = {
  // auth: {
  //   clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '3e08f76f-d69d-428c-915d-2e21bc17a539', // Replace with your Azure AD app client ID
  //   authority: process.env.REACT_APP_AZURE_AUTHORITY || 'https://openrgpolicynet.ciamlogin.com/8b589a55-8bbe-40ca-a5aa-fe616b96c9ce/', // External ID tenant with user flow
  //   redirectUri: window.location.origin, // Always use current domain, ignore env vars
  //   postLogoutRedirectUri: window.location.origin, // Always use current domain, ignore env vars
  //   navigateToLoginRequestUrl: false, // Prevent automatic navigation after login
  // },
  auth: {
    clientId: "3e08f76f-d69d-428c-915d-2e21bc17a539",
    authority: "https://openrgpolicynet.ciamlogin.com/8b589a55-8bbe-40ca-a5aa-fe616b96c9ce/",
    //knownAuthorities: ["openrgpolicynet.ciamlogin.com"],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            console.warn(message);
            return;
          case 2: // LogLevel.Info
            console.info(message);
            return;
          case 3: // LogLevel.Verbose
            console.debug(message);
            return;
        }
      },
    },
  },
};

// Add scopes here for ID token to be used at Micarosoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email', 'https://graph.microsoft.com/User.Read'],
  prompt: 'select_account',
  // Don't override redirectUri for popup requests - let MSAL handle it
}; 

// Alternative redirect request for browsers that have popup issues
export const redirectRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', 'https://graph.microsoft.com/User.Read'],
  prompt: 'select_account',
};

// export const loginRequest = {
//   scopes: ["openid", "profile", "offline_access"],
//   // prompt: "select_account",   // ❌ remove this
// } ;

// export const redirectRequest = {
//   scopes: ["openid", "profile", "offline_access"],
//   // prompt: "select_account",   // ❌ remove this
// } ;


// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

// Configuration for Jira SSO
export const jiraSSOConfig = {
  // Jira SSO endpoint - you'll need to configure this in your Jira instance
  jiraSSOUrl: process.env.REACT_APP_JIRA_SSO_URL || 'https://boards.jira.policy.net' || 'https://matthewmachines.atlassian.net/',
  // Azure AD app registration should have Jira configured as a relying party
  jiraAudience: process.env.REACT_APP_JIRA_AUDIENCE || 'https://boards.jira.policy.net',
  // config/msalConfig.ts

  // Entra "User access URL" deep link for the Atlassian Cloud enterprise app
  aadUserAccessUrl: "",
  // Optional: where to land after SSO (works if you've set RelayState in Entra SAML for Atlassian)
  relayStateTarget: "https://boards.jira.policy.net/jira",
  // Fallback SP-initiated URL (if deep link isn’t set)
  fallbackJiraUrl: "https://boards.jira.policy.net"

};
